export const INFO_CONSTS = {
    SET_INFO_DATA:"SET_INFO_DATA",
};
